"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Popover = _interopRequireDefault(require("../Popover"));

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var PercentageBar = function PercentageBar(_ref) {
  var width = _ref.width,
      data = _ref.data,
      _ref$otherLabel = _ref.otherLabel,
      otherLabel = _ref$otherLabel === void 0 ? 'Other' : _ref$otherLabel;

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      openTooltip = _React$useState2[0],
      setopenTooltip = _React$useState2[1];

  var boldCharWidth = 18;
  var scaledCharWidth = 7;
  var labelCharWidth = 9;
  var otherBar = {
    width: 0,
    title: otherLabel,
    smallLabel: false,
    tooltip: '',
    otherTooltip: []
  };
  var chartBars = data.reduce(function (acc, bar) {
    var smallLabel = false;
    var barPercent = Math.round(bar.share * 1000) / 10;
    var barPixelWidth = bar.share * width - 20;
    var headingFitsInBar = boldCharWidth * (barPercent.toString().length + 1) < barPixelWidth;

    if (!headingFitsInBar) {
      smallLabel = true;
    }

    var scaledHeadingFitsInBar = scaledCharWidth * (barPercent.toString().length + 1) < barPixelWidth;
    var labelFitsInBar = labelCharWidth * (bar.name.length + 1) < barPixelWidth;

    if (!scaledHeadingFitsInBar || !labelFitsInBar) {
      var _otherBar$otherToolti;

      otherBar.width += bar.share;
      (_otherBar$otherToolti = otherBar.otherTooltip) === null || _otherBar$otherToolti === void 0 ? void 0 : _otherBar$otherToolti.push("".concat(bar.name, ": ").concat(Math.round(bar.share * 100), "%"));
      return acc;
    }

    var builtData = Object.assign({}, bar, {
      width: barPercent,
      title: bar.name,
      smallLabel: smallLabel,
      tooltip: "".concat(bar.name, ": ").concat(barPercent, "%")
    });
    return [].concat((0, _toConsumableArray2["default"])(acc), [builtData]);
  }, []);

  if (otherBar.width) {
    if (otherBar.width * width < 70) {
      otherBar.smallLabel = true;
    }

    otherBar.width = Math.round(otherBar.width *= 100);
    chartBars.push(otherBar);
  }

  var classes = useStyles({
    props: {
      ratios: chartBars.map(function (b) {
        return b.width;
      })
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.PercentageBar,
    style: {
      width: width
    }
  }, chartBars.map(function (bar, index) {
    return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
      key: bar.title,
      anchor: /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flexBasis: "".concat(bar.width, "%")
        },
        onMouseEnter: function onMouseEnter() {
          setopenTooltip(index + 1);
        },
        onMouseLeave: function onMouseLeave() {
          setopenTooltip(0);
        }
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: bar.smallLabel ? 'small-label' : ''
      }, bar.width, "%"), /*#__PURE__*/_react["default"].createElement("h4", null, bar.title)),
      open: openTooltip == index + 1,
      placement: "top",
      arrowOffset: 0
    }, bar.otherTooltip ? bar.otherTooltip.map(function (t) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: t
      }, t);
    }) : bar.tooltip);
  }));
};

var _default = PercentageBar;
exports["default"] = _default;
//# sourceMappingURL=index.js.map